import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../../app.routing';
import { environment } from '../../../environments/environment';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';


import { SignalRModule, ConnectionTransports } from 'ng2-signalr';
import { SignalRConfiguration } from 'ng2-signalr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { GridsterModule } from 'angular2gridster';
import { NgxEchartsModule } from 'ngx-echarts';
import { LoadingModule } from 'ngx-loading';
import { LocalStorageModule } from 'angular-2-local-storage';
import { CookieModule } from 'ngx-cookie';
import { NgSelectModule } from '@ng-select/ng-select';
import { WidgetdetailsComponent } from './widgetdetails/widgetdetails.component';
import { WidgetInfoComponent } from './widget-info/widget-info.component';

//SignalR config
export function createConfig(): SignalRConfiguration {
    const c = new SignalRConfiguration();
    c.hubName = environment.hubName;
    c.url = environment.hubConnectionUrl;
    c.logging = true;
    //c.transport = [ConnectionTransports.longPolling];
    c.executeEventsInZone = true; // optional, default is true
    c.executeErrorsInZone = false; // optional, default is false
    c.executeStatusChangeInZone = true; // optional, default is true
    return c;
}


@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        WidgetdetailsComponent,
        WidgetInfoComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule,
        NgxEchartsModule,
        NgxDatatableModule,
        LoadingModule,
        NgSelectModule,
        GridsterModule.forRoot(),
        NgbModule.forRoot(),
        CookieModule.forRoot(),
        SignalRModule.forRoot(createConfig),
        LocalStorageModule.withConfig({
            prefix: 'wip',
            storageType: 'localStorage'
        })
    ],
    exports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule,
        NgxEchartsModule,
        NgxDatatableModule,
        LoadingModule,
        NgSelectModule,
        GridsterModule,
        NgbModule,
        CookieModule,
        SignalRModule,
        LocalStorageModule,
        HeaderComponent,
        FooterComponent,
        WidgetdetailsComponent,
        WidgetInfoComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
    ],
    providers: [

    ]
})

export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/components/shared/shared.module.ts